import React from 'react'

const Camera = (props: any) => {
  return (
    <svg
      {...props}
      fill="currentColor"
      height="100%"
      width="100%"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 350 350">
      <g id="XMLID_505_">
        <g>
          <g>
            <path
              d="M315.47,72.547V56.359c0-13.099-10.657-23.756-23.756-23.756H265.47c-13.099,0-23.756,10.657-23.756,23.756v15.427
                H198.53v-12.5c0-17.134-13.939-31.073-31.073-31.073H65.604c-17.134,0-31.073,13.939-31.073,31.073v13.26
                C14.894,76.289,0,93.577,0,114.286v165c0,23.435,19.065,42.5,42.5,42.5h265c23.435,0,42.5-19.065,42.5-42.5v-165
                C350,93.577,335.106,76.289,315.47,72.547z M261.714,56.359c0-2.071,1.685-3.756,3.756-3.756h26.244
                c2.071,0,3.756,1.685,3.756,3.756v15.427h-33.756V56.359z M54.531,59.286c-0.001-6.105,4.967-11.073,11.073-11.073h101.854
                c6.105,0,11.073,4.967,11.073,11.073v12.5h-124V59.286z M330,279.286c0,12.407-10.094,22.5-22.5,22.5h-265
                c-12.406,0-22.5-10.093-22.5-22.5v-165c0-12.407,10.094-22.5,22.5-22.5h265c12.406,0,22.5,10.093,22.5,22.5V279.286z"
            />
            <path
              d="M125,116.786c-44.112,0-80,35.888-80,80s35.888,80,80,80s80-35.888,80-80S169.112,116.786,125,116.786z M125,256.786
                c-33.084,0-60-26.916-60-60s26.916-60,60-60s60,26.916,60,60S158.084,256.786,125,256.786z"
            />
            <path
              d="M293.728,109.286h-29.333c-11.212,0-20.334,9.122-20.334,20.333v19.333c0,11.212,9.122,20.333,20.334,20.333h29.333
                c11.212,0,20.333-9.122,20.333-20.333V129.62C314.061,118.408,304.939,109.286,293.728,109.286z M294.061,148.953
                c0,0.184-0.149,0.333-0.333,0.333h-29.333c-0.185,0-0.334-0.149-0.334-0.333V129.62c0-0.184,0.149-0.333,0.334-0.333h29.333
                c0.184,0,0.333,0.149,0.333,0.333V148.953z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Camera
